module.exports = __webpack_public_path__ + "static/media/3DPPA13.1206cd2a.jpg";